//IMPLEMENTATION WITH "PROJECTED"

// import styled from "styled-components";
// import { signal } from "@preact/signals-react";
// import { useQueryClient } from "react-query";
// import CheckCircleIcon from "@mui/icons-material/CheckCircle";
// import { Tooltip } from "@mui/material";
// import {
//   useFetchEntities,
//   useAddOrDeleteVehicleIdToTourGroup,
//   useToggleTourGroupVehicleStatus,
// } from "@/reactQueryHooks";
// import CloseIcon from "@mui/icons-material/Close";
// import DirectionsBusIcon from "@mui/icons-material/DirectionsBus";

// interface AssignedRoleBadgeProps {
//   tourGroupId: string;
//   assigneeUsd: any;
//   refetch: () => void;
// }

// interface TourGroup {
//   _id: string;
//   product_id: string;
//   option_id: string;
//   start_time_id: string;
//   vehicle_id: string;
// }

// interface Comment {
//   _id: string;
//   author_id: string;
//   date: string;
//   text: string;
// }

// interface TourGroupSchedule {
//   id: string;
//   role: string;
//   projected?: boolean;
//   _data?: TourGroup;
// }

// interface ScheduleData {
//   _id?: string;
//   tourGroups: TourGroupSchedule[];
//   comments?: Comment[];
//   isDayOff?: boolean;
//   isLeave?: boolean;
//   isProjectedDayOff?: boolean;
//   isProjectedLeave?: boolean;
// request?: {
//   requestBody: string;
//   author_id: string;
//   date: string;
// };
//   user?: string;
//   date?: string;
//   notify?: boolean;
// }

// const BadgeContainer = styled.div<{
//   $isProjected?: boolean;
// }>`
//   display: flex;
//   align-items: center;
//   padding: 6px 10px;
//   border-radius: 18px;
//   background-color: ${({ $isProjected }) =>
//     $isProjected ? "rgba(255, 153, 0, 0.205)" : "#c5f2ddc8"};
//   color: ${({ $isProjected }) =>
//     $isProjected ? "rgba(151, 91, 0, 0.8)" : "#2e7d5b"};
//   font-size: 12px;
//   font-weight: 500;
//   box-shadow: 0 2px 4px rgba(0, 0, 0, 0.06);
//   gap: 6px;
//   transition: all 0.2s ease;

//   &:hover {
//     box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
//   }
// `;

// const CheckIconContainer = styled.div<{
//   isProjected: boolean;
// }>`
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   cursor: pointer;

//   //hover
//   &:hover {
//     svg {
//       color: ${(props) =>
//         props.isProjected ? "#2e7d5b" : "rgba(151 91 0 / 0.94)"};
//     }
//   }
// `;

// const Info = styled.div`
//   display: flex;
//   align-items: center;
//   background-color: rgba(255, 255, 255, 0.6);
//   padding: 2px 6px;
//   border-radius: 12px;
//   white-space: nowrap;
//   overflow: hidden;
//   text-overflow: ellipsis;
//   font-size: 11px;
//   max-width: 150px;

//   svg {
//     font-size: 12px;
//     margin-right: 4px;
//     color: #2e7d5b;
//     flex-shrink: 0;
//   }
// `;

// const CheckIcon = styled.div`
//   margin-right: 4px;
//   color: #2e7d5b;
//   display: flex;
//   align-items: center;
//   justify-content: center;

//   svg {
//     font-size: 16px;
//   }
// `;

// const RemoveIconContainer = styled.div`
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   width: 20px;
//   height: 20px;
//   border-radius: 50%;
//   background-color: rgba(255, 255, 255, 0.6);
//   cursor: pointer;
//   flex-shrink: 0;
//   margin-left: 2px;

//   &:hover {
//     background-color: rgba(255, 255, 255, 0.8);
//   }

//   svg {
//     font-size: 12px;
//   }
// `;

// export const refreshScheduleById = signal("empty_signal");

// const AssignedVehicleBadge = ({
//   refetch,
//   tourGroupId,
//   vehicleId,
//   isProjected,
// }: {
//   refetch: () => void;
//   tourGroupId: string;
//   vehicleId: string;
//   isProjected?: boolean;
// }) => {
//   const queryClient = useQueryClient();
//   const { data: entities } = useFetchEntities() as any;
//   const vehicle = entities.data.vehicles.find((v: any) => v._id === vehicleId);
//   const { mutateAsync: addOrDeleteVehicleIdToTourGroup } =
//     useAddOrDeleteVehicleIdToTourGroup() as any;

//   const { mutateAsync: toggleTourGroupVehicleStatus } =
//     useToggleTourGroupVehicleStatus() as any;

//   return (
//     <BadgeContainer $isProjected={isProjected}>
//       <Tooltip title={isProjected ? "Mark as confirmed" : "Mark as projected"}>
//         <CheckIconContainer
//           isProjected={isProjected ?? false}
//           onClick={async () => {
//             try {
//               await toggleTourGroupVehicleStatus(tourGroupId);

//               await queryClient.invalidateQueries({
//                 queryKey: ["VEHICLE_SCHEDULE_DATA_BY_DATE_RANGE"],
//               });

//               refetch();
//             } catch (error) {
//               alert("Error. Please try again.");
//               console.error("Error", error);
//             }
//           }}
//         >
//           <CheckCircleIcon
//             color={isProjected ? "warning" : "success"}
//             fontSize="small"
//           />
//         </CheckIconContainer>
//       </Tooltip>

//       <Info>
//         <DirectionsBusIcon />
//         <span>{vehicle?.plate}</span>
//       </Info>
//       <RemoveIconContainer
//         onClick={async () => {
//           try {
//             await addOrDeleteVehicleIdToTourGroup({
//               tour_group_id: tourGroupId,
//               vehicle_id: vehicleId,
//             });

//             await queryClient.invalidateQueries({
//               queryKey: ["VEHICLE_SCHEDULE_DATA_BY_DATE_RANGE"],
//             });

//             refetch();
//           } catch (error) {
//             alert("Error removing vehicle from tour group. Please try again.");
//             console.error("Error removing vehicle from tour group:", error);
//           }
//         }}
//       >
//         <CloseIcon color="error" />
//       </RemoveIconContainer>
//     </BadgeContainer>
//   );
// };

// export default AssignedVehicleBadge;

//IMPLEMENTATION WITHOUT "PROJECTED"

import styled from "styled-components";
import {
  useFetchEntities,
  useAddOrDeleteVehicleIdToTourGroup,
} from "@/reactQueryHooks";
import CloseIcon from "@mui/icons-material/Close";
import { refreshVehicleScheduleById } from "../staff_planner/signalStore";
import DirectionsBusIcon from "@mui/icons-material/DirectionsBus";

const BadgeContainer = styled.div<{
  $isProjected?: boolean;
}>`
  display: flex;
  align-items: center;
  padding: 6px 10px;
  border-radius: 18px;
  background-color: #c5f2ddc8;
  color: #2e7d5b;
  font-size: 12px;
  font-weight: 500;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.06);
  gap: 6px;
  transition: all 0.2s ease;

  &:hover {
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  }
`;

const Info = styled.div`
  display: flex;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.6);
  padding: 2px 6px;
  border-radius: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 11px;
  max-width: 150px;

  svg {
    font-size: 12px;
    margin-right: 4px;
    color: #2e7d5b;
    flex-shrink: 0;
  }
`;

const RemoveIconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.6);
  cursor: pointer;
  flex-shrink: 0;
  margin-left: 2px;

  &:hover {
    background-color: rgba(255, 255, 255, 0.8);
  }

  svg {
    font-size: 12px;
  }
`;

const AssignedVehicleBadge = ({
  refetch,
  date,
  tourGroupId,
  vehicleId,
}: {
  refetch: () => void;
  date: string;
  tourGroupId: string;
  vehicleId: string;
}) => {
  const { data: entities } = useFetchEntities() as any;
  const vehicle = entities.data.vehicles.find((v: any) => v._id === vehicleId);
  const { mutateAsync: addOrDeleteVehicleIdToTourGroup } =
    useAddOrDeleteVehicleIdToTourGroup() as any;

  return (
    <BadgeContainer>
      <Info>
        <DirectionsBusIcon />
        <span>{vehicle?.plate}</span>
      </Info>
      <RemoveIconContainer
        onClick={async () => {
          try {
            await addOrDeleteVehicleIdToTourGroup({
              tour_group_id: tourGroupId,
              vehicle_id: vehicleId,
            });
            refreshVehicleScheduleById.value = {
              vehicleId: vehicleId,
              date: date,
            };
            refetch();
          } catch (error) {
            alert("Error removing vehicle from tour group. Please try again.");
            console.error("Error removing vehicle from tour group:", error);
          }
        }}
      >
        <CloseIcon color="error" />
      </RemoveIconContainer>
    </BadgeContainer>
  );
};

export default AssignedVehicleBadge;
